import { NavigationCards } from "./navigation-cards";
import { DashboardLayout } from "./DashboardLayout";
import { Exams } from "src/components/ui/exams";
import { DashboardHeader } from "./dashboard-header";
import { Notifications } from "./notifications";
import { FAQCard } from "src/components/ui/faq-card";
import GuidelineBubble from "src/components/ui/guideline-bubble";
import ExamInstruction from "./examInstruction";
import { Link } from "react-router-dom";

export const DashboardView = () => {
  return (
    <DashboardLayout>
      <main className="flex flex-grow flex-col gap-8 px-2 py-3 lg:overflow-auto">
        <DashboardHeader />
        <div>
          <div className="mx-auto overflow-auto rounded-lg border p-3 shadow-lg min-h-[250px] lg:min-h-[210px] lg:w-[600px] xl:w-[1000px]">
            <Exams />
          </div>
          <div className="flex justify-center my-6">
            <Link to="/applied-posts" className="bg-primary rounded-lg px-3 py-2 text-white">Book Your Slot</Link>
          </div>
          <ExamInstruction/>
        </div>
        <section className="flex h-full w-full flex-col items-center justify-center gap-8 md:gap-20">
          <div className="flex flex-col gap-20 justify-self-center md:flex-row">
            <NavigationCards />
          </div>
        </section>
        <Notifications />
        <FAQCard className="pt-16 lg:hidden" />
      </main>
      <GuidelineBubble />
    </DashboardLayout>
  );
};
